import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Appointment required — no walk-ins allowed",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Predictable turnaround",
      "Ideal for upcoming trips",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service",
      "Good for planned travel",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "Workload & wait times shift with shutdowns and budget fights",
      "In-person clerk appointment required",
      "No document review — errors cause rejection",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Can't upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
];

export default function EdmondProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Edmond"
      headingExtra="OK"
      introText="Edmond travelers — UCO students studying abroad, Oklahoma Christian University mission teams, and north OKC metro families — have several options for getting a passport fast. Here's how they compare, and why most Edmond residents choose a registered State Department courier."
      options={options}
      emergencyDescription="Oklahoma has ZERO passport agencies — 4M+ residents have no in-state emergency option. Closest: Dallas ~210 mi via I-35 (3.5+ hrs). UCO sends hundreds abroad every semester — a Broncho student discovering an expired passport 48 hours before a flight to Barcelona faces a 7+ hour round trip on Tornado Alley's most dangerous corridor. The 1999 Bridge Creek-Moore F5 and 2013 Moore EF5 both crossed I-35 within 20 miles of Edmond — when severe weather shuts down I-35, Edmond is severed from Dallas's single agency with zero alternate route through rural Oklahoma. Ice storms (Dec–Feb) add hours — and there is no other agency in any direction for 200+ miles."
      disclaimerText="*Processing speed depends on eligibility and documentation. Not all applicants qualify for Regional Agency Processing."
    />
  );
}